// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_O7a","cls2":"CreateSocialItemModal-cls2_Sue CreateSocialItemModal-cls1_O7a"};